import { CURRENCY } from "../../constants";

export default function Currency({ currency }) {
  return (
    <>
      {currency === CURRENCY.INR ? (
        "INR "
      ) : currency === CURRENCY.SGD ? (
        "SGD "
      ) : currency === CURRENCY.PKR ? (
        "PKR "
      ) : currency === CURRENCY.LKR ? (
        "LKR "
      ) : currency === CURRENCY.BDT ? (
        "BDT "
      ) : currency === CURRENCY.USD ? (
        "USD "
      ) : currency === CURRENCY.CNY ? (
        "CNY "
      ) : (
        "- "
      )}
      {/* &nbsp; */}
    </>
  );
}
